import { requestData, requestList } from '@/api/request';
import type { Environment } from '@/api/types';

export async function getEnvironments() {
  return requestList<Environment>({
    url: 'environments/',
  });
}

export async function getEnvironment(id: number) {
  return requestData<Environment>({
    url: `environments/${id}/`,
  });
}